import React from "react";
import { cn } from "@/lib/utils";

export function LiveBadge({ className, pulse = true }) {
  return (
    <span
      data-testid="live-badge"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full bg-live px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-white shadow-sm",
        className
      )}
    >
      <span className="relative flex h-2 w-2">
        {pulse && (
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/80 opacity-75" />
        )}
        <span className="relative inline-flex h-2 w-2 rounded-full bg-white" />
      </span>
      Live
    </span>
  );
}

export default LiveBadge;
